import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Button from '../common/Button';
import { Divider } from '../common/Divider';
import { 
  FaYoutube, 
  FaPodcast, 
  FaWhatsapp,
  FaApple,
  FaGoogle,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt
} from 'react-icons/fa';
import { SiPodcastaddict } from 'react-icons/si';

const Footer = () => {
  return (
    <>
      <FooterTopDivider />
      <FooterWrapper>
        <FooterContent>
          <FooterSection>
            <h3>Embassy of Life Chapel</h3>
            <ContactInfo>
              <ContactItem>
                <FaMapMarkerAlt />
                <div>
                  <p>Head Office: South Patasi - Kumasi</p>
                  <p>Ghana</p>
                </div>
              </ContactItem>
              <ContactItem>
                <FaPhone />
                <div>
                  <p><a href="tel:+233540122670">0540 122 670</a></p>
                  <p><a href="tel:+233540122671">0540 122 671</a></p>
                </div>
              </ContactItem>
              <ContactItem>
                <FaEnvelope />
                <div>
                  <p><a href="mailto:embassyoflifechapeloffice@gmail.com">embassyoflifechapeloffice@gmail.com</a></p>
                </div>
              </ContactItem>
            </ContactInfo>
          </FooterSection>

          <FooterSection>
            <h3>Quick Links</h3>
            <FooterLinks>
              <Link to="/about">About Us</Link>
              <Link to="/next-steps">Next Steps</Link>
              <Link to="/ministries">Ministries</Link>
              <Link to="/events">Events</Link>
              <Link to="/give">Give</Link>
            </FooterLinks>
          </FooterSection>

          <FooterSection>
            <h3>Connect With Us</h3>
            <p>Join our community and stay updated with the latest news and events.</p>
            <Button to="/contact" variant="primary">Contact Us</Button>
            <SocialLinks>
              <a href="https://www.youtube.com/@embassyoflifechapel3466" target="_blank" rel="noopener noreferrer" title="YouTube">
                <FaYoutube />
              </a>
              <a href="https://podcasts.apple.com/us/podcast/paul-osei-yaw-afoakwa-audio-podcast/id1460282793" target="_blank" rel="noopener noreferrer" title="Apple Podcasts">
                <FaApple />
              </a>
              <a href="https://podcastaddict.com/podcast/paul-osei-yaw-afoakwa-audio-podcast/2360824" target="_blank" rel="noopener noreferrer" title="Podcast Addict">
                <SiPodcastaddict />
              </a>
              <a href="https://www.podbean.com/podcast-detail/ipucv-1a4a7b/Paul-Osei-Yaw-Afoakwa-Audio-Podcast" target="_blank" rel="noopener noreferrer" title="Podbean">
                <FaPodcast />
              </a>
              <a href="https://wa.me/233540122671" target="_blank" rel="noopener noreferrer" title="WhatsApp">
                <FaWhatsapp />
              </a>
            </SocialLinks>
          </FooterSection>
        </FooterContent>
        
        <FooterBottom>
          <p>&copy; {new Date().getFullYear()} Embassy of Life Chapel. All rights reserved.</p>
        </FooterBottom>
      </FooterWrapper>
    </>
  );
};

const FooterTopDivider = styled(Divider)`
  margin-bottom: -50px;
  z-index: 2;
  height: 100px;
  background: linear-gradient(to bottom, white, transparent);
  
  &::before {
    width: 40%;
    background: linear-gradient(
      to right,
      transparent,
      ${props => props.theme.colors.primary}22,
      ${props => props.theme.colors.primary}66,
      ${props => props.theme.colors.primary}22,
      transparent
    );
  }

  &::after {
    font-size: 2rem;
    background: white;
    padding: 0 2.5rem;
    color: ${props => props.theme.colors.primary};
  }
`;

const FooterWrapper = styled.footer`
  position: relative;
  background: linear-gradient(
    to bottom,
    ${props => props.theme.colors.primary},
    #2A0038
  );
  color: ${props => props.theme.colors.background.light};
  padding: ${props => props.theme.spacing.xl} 0 0;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  }
`;

const FooterContent = styled.div`
  position: relative;
  z-index: 2;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing.md};
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: ${props => props.theme.spacing.lg};
  margin-bottom: ${props => props.theme.spacing.md};

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    gap: ${props => props.theme.spacing.md};
    padding: 0 ${props => props.theme.spacing.sm};
  }

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    gap: ${props => props.theme.spacing.sm};
    padding: 0 1rem;
  }
`;

const FooterSection = styled.div`
  h3 {
    font-family: ${props => props.theme.fonts.secondary};
    font-size: 1.1rem;
    margin-bottom: ${props => props.theme.spacing.sm};
    color: white;
    font-weight: 600;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  }

  p {
    margin-bottom: ${props => props.theme.spacing.xs};
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.95);
  }

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    text-align: left;
    padding: 1rem 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    
    &:last-child {
      border-bottom: none;
    }
    
    h3 {
      font-size: 1rem;
      text-align: left;
    }
    
    p {
      font-size: 0.85rem;
      text-align: left;
    }
  }
`;

const ContactInfo = styled.div`
  margin-top: ${props => props.theme.spacing.md};
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.md};

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    gap: ${props => props.theme.spacing.sm};
    margin-top: ${props => props.theme.spacing.sm};
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${props => props.theme.spacing.sm};

  svg {
    color: ${props => props.theme.colors.secondary};
    font-size: 1.2rem;
    margin-top: 2px;
    flex-shrink: 0;
  }

  div, p {
    margin: 0;
    line-height: 1.4;
  }

  a {
    color: inherit;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: ${props => props.theme.colors.secondary};
    }
  }

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    justify-content: flex-start;
    text-align: left;
    flex-direction: row;
    gap: 0.75rem;
    align-items: flex-start;
    
    svg {
      font-size: 1.1rem;
      margin-top: 2px;
    }
  }
`;

const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sm};

  a {
    color: ${props => props.theme.colors.background.light};
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: ${props => props.theme.colors.primary};
    }
  }

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    align-items: flex-start;
    gap: 0.75rem;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${props => props.theme.spacing.md};
  margin-top: ${props => props.theme.spacing.lg};

  a {
    color: ${props => props.theme.colors.background.light};
    text-decoration: none;
    transition: all 0.3s ease;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);

    &:hover {
      color: ${props => props.theme.colors.secondary};
      background: rgba(255, 255, 255, 0.15);
      transform: translateY(-3px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }
  }

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    justify-content: flex-start;
    gap: ${props => props.theme.spacing.sm};
    margin-top: ${props => props.theme.spacing.md};
    
    a {
      width: 40px;
      height: 40px;
      font-size: 1.3rem;
    }
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: ${props => props.theme.spacing.xl};
  padding: ${props => props.theme.spacing.md};
  text-align: center;
  font-size: 0.9rem;
  background: rgba(0, 0, 0, 0.1);

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    margin-top: ${props => props.theme.spacing.lg};
    padding: ${props => props.theme.spacing.sm};
    font-size: 0.8rem;
  }
`;

export default Footer; 